export default "__VITE_ASSET__B1zu2H_S__"